import React, { useState } from 'react';
import { useProductShowcaseData } from '../hooks/useProductShowcaseData';
import ProductGrid from './ProductGrid';
import ProductDetailModal from './ProductDetailModal';
import LoadingSpinner from '../../../components/common/LoadingSpinner';

export default function ProductShowcasePage() {
  // Modal states
  const [selectedProductForDetails, setSelectedProductForDetails] = useState(null);
  
  // Data hooks
  const { 
    products, 
    loading, 
    selectedBrowsingGroup, 
    setSelectedBrowsingGroup, 
    availableBrowsingGroups 
  } = useProductShowcaseData();

  // Handle product selection for details
  const handleProductSelect = (product) => {
    setSelectedProductForDetails(product);
  };

  // Close product details modal
  const handleCloseProductDetails = () => {
    setSelectedProductForDetails(null);
  };

  // Loading state
  if (loading && products.length === 0) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#F7FBFC] to-[#E8F4F8] pt-20">
        <div className="flex justify-center items-center h-96">
          <LoadingSpinner size="lg" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F7FBFC] to-[#E8F4F8] pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Product Grid */}
        <div className="flex gap-6">
          <div className="flex-1">
            <ProductGrid
              products={products}
              selectedBrowsingGroup={selectedBrowsingGroup}
              setSelectedBrowsingGroup={setSelectedBrowsingGroup}
              availableBrowsingGroups={availableBrowsingGroups}
              onProductSelect={handleProductSelect}
            />
          </div>
        </div>

        {/* Product Detail Modal */}
        {selectedProductForDetails && (
          <ProductDetailModal
            product={selectedProductForDetails}
            onClose={handleCloseProductDetails}
          />
        )}
      </div>
    </div>
  );
}
